import React from 'react';
import { useTheme, Box, Unstable_Grid2 as Grid, Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import ClientManifestCard from '../client-manifest-card';
import EtlResourcesCard from '../etl-resources-card';
import ClientCensusCard from '../client-census-card';

interface IClientsListRowTemplateProps {
  client?: IClient
}

export default function ClientsListRowTemplate (props: IClientsListRowTemplateProps) {

  const theme = useTheme();

  return (
    <Box sx={{ bgcolor: theme.palette.grey[100], overflow: 'hidden'}}>
      <Grid container spacing={1} sx={{ m: .5}}>
        <Grid xs>
          <ClientManifestCard client={props.client}  />
        </Grid>
        <Grid xs={8}>
          <EtlResourcesCard client={props.client}  />
        </Grid>
        <Grid xs={2}>
          <ClientCensusCard client={props.client}  />
        </Grid>
      </Grid>
    </Box>
  );
}



// return (
  //   <Grid 
  //     container
  //     sx={{        
  //       width: '100%',
  //       height: '100%',
  //       bgcolor: theme.palette.grey[100]}}>

  //     <Typography variant="h5" sx={{ fontSize: '0.7rem', mx: 4, mt: 2, mb:1, textTransform: 'uppercase', letterSpacing: '0.1em' }} color="text.secondary">
  //       Snapshot Manifest
  //     </Typography>

  //     <Grid item xs={12} sx={{ mx: 2, mb: 2, flexWrap: 'nowrap' }}>
  //       <TableContainer component={Paper}>
  //         <Table sx={{ width: '100%' }} aria-label="simple table">
  //           <TableHead>
  //             <TableRow>
  //               <TableCell align="left" style={{ width: '30%', ...tableHeaderStyle }}>File Category</TableCell>
  //               <TableCell align="left" style={{ width: '70%', ...tableHeaderStyle }}>PII Attributes</TableCell>           
  //             </TableRow>
  //           </TableHead>
  //           <TableBody>
  //             {sourceFiles.map((item, index) => (
  //               <TableRow key={item.Category} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>                  
  //                 <TableCell align="left" style={{...tableCellStyle}}>{item.Category}</TableCell>
  //                 <TableCell align="left" style={{...tableCellStyle}}>{item.PiiAttributes}</TableCell>
  //               </TableRow>
  //             ))}
  //           </TableBody>
  //         </Table>
  //       </TableContainer>
  //     </Grid>
  //     {/* <OpenInNewIcon style={{...iconStyle}}/> */}

  //     <Typography variant="h5" sx={{ fontSize: '0.7rem', mx: 4, mt:1, mb:1, textTransform: 'uppercase', letterSpacing: '0.1em' }} color="text.secondary">
  //       ETL Pipeline
  //     </Typography>

      // <Grid item xs={12} sx={{ mx: 2, mb: 2 }}>
      //   <TableContainer component={Paper}>
      //     <Table sx={{ width: '100%' }} aria-label="simple table">
      //       <TableHead>
      //         <TableRow>
      //           <TableCell align="left" style={{ width: '10%', ...tableHeaderStyle }}>Resource</TableCell>
      //           <TableCell align="left" style={{ width: '10%', ...tableHeaderStyle }}>Bronze</TableCell>
      //           <TableCell align="left" style={{ width: '10%', ...tableHeaderStyle }}>Silver</TableCell>
      //           <TableCell align="left" style={{ width: '10%', ...tableHeaderStyle }}>Gold</TableCell>
      //         </TableRow>
      //       </TableHead>
      //       <TableBody>
      //         <TableRow key={0} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
      //           <TableCell align="left" style={{...tableCellStyle}}>Glue Catalog</TableCell>
      //           <TableCell align="left" style={{...tableCellStyle}}>{props.client?.AmaPipeline?.BronzeDb}</TableCell>
      //           <TableCell align="left" style={{...tableCellStyle}}>{props.client?.AmaPipeline?.SilverDb}</TableCell>
      //           <TableCell align="left" style={{...tableCellStyle}}>{props.client?.AmaPipeline?.GoldDb}</TableCell>
      //         </TableRow>
      //         <TableRow key={1} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
      //           <TableCell align="left" style={{...tableCellStyle}}>Glue Job</TableCell>
      //           <TableCell align="left" style={{...tableCellStyle}}>ama_shared_remove_pii_script_job</TableCell> 
      //           <TableCell align="left" style={{...tableCellStyle}}>{props.client?.AmaPipeline?.SilverGlueJobName}</TableCell>
      //           <TableCell align="left" style={{...tableCellStyle}}>{props.client?.AmaPipeline?.GoldGlueJobName}</TableCell>
      //         </TableRow>
      //       </TableBody>
      //     </Table>
      //   </TableContainer>
      // </Grid>

  //   </Grid>
  // );

//   const sourceFiles = props.client?.AmaPipeline?.SourceFiles || [];



  // const getManifestItemsForClient = (client: IClient | undefined) : Array<IManifestItem> =>   {
  //   if (!client || !client.AmaPipeline?.SourceFiles) return [];
  //   const manifestItemsObj : any = client.AmaPipeline?.SourceFiles;   // eslint-disable-line
  //   const manifestItems : Array<IManifestItem> = [];
  //   for (const key in manifestItemsObj) {
  //       const manifestItem = manifestItemsObj[key] as IManifestItem;
  //       manifestItem.Category = key;
  //       manifestItems.push(manifestItem);
  //   }
  //   return manifestItems;
  // }


// const manifestItems = getManifestItemsForClient(props.client);
// console.log(`ClientDetailRowTemplate :: client: ${JSON.stringify(props.client)}\nitemCount: ${manifestItems.length}`);


{/* <Grid item xs={4} key={index}>
<Card
  sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}
>
  <CardContent>
    <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center' }}>
      
      {item.Category}
    </Typography>
  </CardContent>
</Card>
</Grid> */}

            {/* <CardContent>
              <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                Bronze
              </Typography>
              <Typography variant="h5" component="div">
                heading
              </Typography>
              <Typography sx={{ mb: 1.5 }} color="text.secondary">
                adjective
              </Typography>
              <Typography variant="body2">
                well meaning and kindly.
                <br />
              </Typography>
            </CardContent> */}
            {/* <CardActions>
              <Button size="small">Learn More</Button>
            </CardActions> */}
          {/* <Card sx={{ minWidth: 275, height:150, margin: 2 }}>
            <CardContent>
              <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                Bronze
              </Typography>
              <Typography variant="h5" component="div">
                heading
              </Typography>
              <Typography sx={{ mb: 1.5 }} color="text.secondary">
                adjective
              </Typography>
              <Typography variant="body2">
                well meaning and kindly.
                <br />
              </Typography>
            </CardContent>
            <CardActions>
              <Button size="small">Learn More</Button>
            </CardActions>
          </Card> */}

{/* <Grid container spacing={2}>
{Array.from({ length: 16 }, (_, index) => (
  <Grid item xs={3} key={index}>
    <Paper elevation={3} sx={{ padding: 2 }}>
      <Typography variant="h6">Client {index + 1}</Typography>
      <Typography variant="body1">Name: {props.client.ClientId}</Typography>
      <Typography variant="body1">Email: {props.client.DisplayName}</Typography>
    </Paper>
  </Grid>
)}
</Grid> */}


      {/* <Grid item xs={3} key={1}>
        <Paper elevation={3} sx={{ padding: 2 }}>
          <div>Item</div>
        </Paper>
      </Grid>
      <Grid item xs={3} key={2}>
        <Paper elevation={3} sx={{ padding: 2 }}>
          <div>Item</div>
        </Paper>
      </Grid>
      <Grid item xs={3} key={3}>
        <Paper elevation={3} sx={{ padding: 2 }}>
          <div>Item</div>
        </Paper>
      </Grid> */}